/* Sui Story — tabbed sections (The Patch Edit, Every Thread a Tradition).
   Markup contract:
     [data-tabs]
       [data-tab="key"]            (button)  — one per tab
       [data-tab-panel="key"]                — matching panel
   First tab/panel is active by default. Re-inits on 'suistory:page:init'. */
(function () {
  var S = (window.SuiStory = window.SuiStory || {});

  function initTabs(scope) {
    (scope || document).querySelectorAll('[data-tabs]').forEach(function (root) {
      if (root.__tabsInit) return;
      root.__tabsInit = true;

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-tab-panel]'));
      if (!tabs.length) return;

      function activate(key) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-tab') === key;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-tab-panel') === key;
          p.classList.toggle('is-active', on);
          if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
        });
        // let any sliders inside the freshly shown panel measure themselves
        if (S.refreshSliders) S.refreshSliders(root);
      }

      tabs.forEach(function (t) {
        t.setAttribute('role', 'tab');
        t.addEventListener('click', function (e) {
          e.preventDefault();
          activate(t.getAttribute('data-tab'));
        });
      });

      // default: an existing is-active tab, else the first
      var initial = root.querySelector('[data-tab].is-active') || tabs[0];
      activate(initial.getAttribute('data-tab'));
    });
  }

  S.initTabs = initTabs;
  document.addEventListener('suistory:page:init', function (e) {
    initTabs(e.detail && e.detail.scope);
  });
})();
